<template>
  <div id = "mandoconnection">
    <div class = "bar">
      <span class = "material-icons md-24">settings_remote</span>
      <button v-if = "connected" v-on:click = "stop()" class = "btn btn-bg-colored">Desconectar</button>
    </div>
    <p>Socket: {{this.connected}}</p>
    <p>Messages: {{this.messagecount}}</p>
    <p>Last Sketch ID: <span class='is-size-7'>  {{this.lastSketchid}} </span></p>
    <p>Last IP: {{this.lastIP}}</p>
    <ul id="v-for-object" class="demo">
      <li v-for="(value, name, index) in ipList" v-bind:key="index">
        {{ value }} {{ name }}
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import io from 'socket.io-client'

export default {
  name: 'ApiMplMando',
  watch: {
    'editorConfig.isSketchRunning': function (isSketchRunning) {
      console.log('isSketchRunning ' + isSketchRunning)
      if (isSketchRunning === true) {
        this.play()
      } else {
        this.stop()
      }
    }
  },
  methods: {
    connect () {
      console.log('connect')
      // si no estamos conectados
      if (!this.connected === true) {
        this.init()
      }
    },
    stop () {
      console.log('disconnect')
      if (this.socket) this.socket.disconnect()
      this.connected = false
    },
    play () {
      this.connect()
    },
    init () {
      // connect to localhost presently
      this.socket = new io.connect('http://127.0.0.1:2526')
      this.connected = true
      console.log('empezando')
      this.socket.on('play', this.processmsg)
    },
    processmsg (currentMsg) {
      this.messagecount++
      console.log('newMessage')

      if (typeof currentMsg.playSketch !== undefined) {
        console.log(currentMsg.id)
        this.lastSketchid=currentMsg.id
        //this.$emit('playSketch',currentMsg.id )
        this.lastIP= currentMsg.ip
        if (this.ipList[currentMsg.ip] === undefined){
          this.ipList[currentMsg.ip] = 1
          this.$emit('playSketch',currentMsg.id ) // AQUÍ ES DONDE ENVIAMOS LA SEÑAL PARA CAMBIAR DE SKETCH
        } else {
          this.ipList[currentMsg.ip] += 1
          if(this.ipList[currentMsg.ip] < this.MAX_CHANGES_BY_IP) {
            this.$emit('playSketch',currentMsg.id ) // AQUÍ ES DONDE ENVIAMOS LA SEÑAL PARA CAMBIAR DE SKETCH
          }
        }
      }
    }
  },
  data () {
    return {
      isPlaying: false,
      isRepeatingVideo: false,
      socket: null,
      connected: false,
      messagecount: 0,
      lastSketchid: '',
      lastIP:'',
      ipList: {},
      MAX_CHANGES_BY_IP: 4

    }
  },
  computed: {
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  beforeDestroy () {
    this.stop()
  }
}
</script>

<style lang="less" scoped>

#mandoconnection {
  padding: 10px;
  max-height: 300px;
  overflow: scroll
}

.bar {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
}

button {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectPlayer/ApiMlpMando.vue